/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class BackupRegionsFilters {
  'containsAllOf'?: Array<string>;
  'containsAnyOf'?: Array<string>;
  'containsNoneOf'?: Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "containsAllOf",
      "baseName": "containsAllOf",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "containsAnyOf",
      "baseName": "containsAnyOf",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "containsNoneOf",
      "baseName": "containsNoneOf",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return BackupRegionsFilters.attributeTypeMap;
  }

  public constructor() {
  }
}

